import React from 'react';
interface Props {
  content: string;
}
function Snackbar(props: Props) {
  return (
    <div className="pop-up-snack-bar-div" aria-live="polite">
      <div className="pop-up-snack-bar">
        <div className="snack-msg body-text-2">{props.content}</div>
      </div>
    </div>
  );
}

export default Snackbar;
